// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bMLl","right":"styles_right__1WE9B"};